import React, { useEffect } from "react";
import AuthLayout from "../layouts/auth";
import { Spinner } from "../components/ui/spinner";
import Cookie, { JWT_COOKIE_NAME } from "../lib/cookie";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../contexts/I18nProvider";

function Logout() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (navigate) {
      localStorage.removeItem("user");
      Cookie.remove(JWT_COOKIE_NAME);
      setTimeout(() => {
        navigate("/");
        window.location.reload();
      }, Math.random() * 2000 + 1000);
    }
  }, [navigate]);
  return (
    <AuthLayout>
      <Spinner /> {t('pages.logout.message')}
    </AuthLayout>
  );
}

export default Logout;
